module.exports = __webpack_public_path__ + "img/scientificBanner2.c357af6f.png";